import { render, staticRenderFns } from "./commonly.vue?vue&type=template&id=c59a6276&scoped=true&"
import script from "./commonly.vue?vue&type=script&lang=js&"
export * from "./commonly.vue?vue&type=script&lang=js&"
import style0 from "./commonly.vue?vue&type=style&index=0&id=c59a6276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59a6276",
  null
  
)

export default component.exports